module.exports = __webpack_public_path__ + "static/media/ticon4.a324d96e.webp";